// extracted by mini-css-extract-plugin
module.exports = {"container":"ButtonD_container__1PPpo","title":"ButtonD_title__3ZGl2","rightIcon":"ButtonD_rightIcon__3aARW","leftIcon":"ButtonD_leftIcon__2Ow4E"};